/* bf26y-r14.js (13 Oct 2026, r14). Loaded last from snippets/bf26a-a11y.liquid. Rollback: delete the two r14 lines there.
   1 copy rules: delivery and dispatch times, free shipping line, exchanges and refunds, the unsourced '82% of customers also bought' heading, set CTA shipping line, support email.
      The text lives in big page templates and section settings (over the 16KB file limit for a single write), so it is corrected where it renders.
   2 sold-out colour and size options cannot be selected (disabled and greyed), worked out from /products/<handle>.js for the options currently picked
   3 automatic mystery gift adds are serialised and re-check the cart first, so two adds a few seconds apart cannot make two gift lines
   r19: pill options (no .color-swatch) mark their own label as sold out, not the whole option group. Backup: bf26y-r14-bak-20261013-r19.js */
(function () {
  function rkLazy(fn, own) { var go = function () { if (window.BF26 && BF26.lazy) BF26.lazy(fn); else own(); }; if ((window.BF26 && BF26.lazy) || document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go); } /* 21 Oct 2026: shared sweep in bf26-core.js */
  var path = location.pathname;
  var handle = (path.match(/^\/products\/([^\/]+)/) || [])[1];
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }

  /* 3 */
  (function () {
    if (window.__bf26yGiftGuard || !window.fetch) return;
    window.__bf26yGiftGuard = 1;
    var GID = 50544476749989, of = window.fetch, chain = Promise.resolve();
    function isAuto(i) { return Number(i.id) === GID && i.properties && (i.properties._bf_auto || i.properties._bf_free); }
    window.fetch = function (u, o) {
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && typeof o.body === 'string' && o.body.charAt(0) === '{') {
          var b = JSON.parse(o.body), items = b.items || [];
          if (items.some(isAuto)) {
            var run = function () {
              return of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
                var has = (c.items || []).some(function (l) { return Number(l.variant_id) === GID; });
                if (!has) return of(u, o);
                var keep = items.filter(function (i) { return !isAuto(i); });
                if (!keep.length) return new Response(JSON.stringify({ items: [] }), { status: 200, headers: { 'Content-Type': 'application/json' } });
                b.items = keep;
                return of(u, Object.assign({}, o, { body: JSON.stringify(b) }));
              });
            };
            var p = chain.then(run, run);
            chain = p.catch(function () {});
            return p;
          }
        }
      } catch (e) {}
      return of.apply(this, arguments);
    };
  })();

  /* 1 */
  /* r55 FX2 (15 Oct 2026): the homepage copy (dispatch, delivery, free shipping, set CTA) now sits in templates/index.json as final text, so its rules are gone:
     no text flips after first paint (DESIGN 1.5). Rules with no source left anywhere in the theme or on the rendered pages were removed too
     (AU$75, 15-day refunds, exchanges, '82% of customers also bought', Free shipping in Australia, next-day dispatch from Sydney, .com.au email).
     Still needed, because the old text is in other owners' templates: the 2-6 / 2-8 day delivery line (templates/page.gift-sets.json)
     and 'Next day dispatch' (templates/product.softclip-hair-clip.json, blocks/product_buy-buttons.liquid). Delete these once those sources are fixed. */
  var DEL = 'Orders dispatch next day while your colour is in stock with us, otherwise in 1 to 3 business days. Delivery takes 3-5 business days in Australia. International orders take 7 to 10 days.';
  var RULES = [
    [/Australian orders typically arrive within 2(?:-| to )[68] business days after dispatch\./, DEL]
  ];
  var KEY = /arrive within/i; /* 21 Oct 2026: 'Next day dispatch' is the wording again (Alexander), so its rewrite rule is gone */
  function copy() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var p = n.parentNode && n.parentNode.nodeName;
      return (p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT' || p === 'TEXTAREA') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    } }), n, v, k;
    while ((n = w.nextNode())) {
      v = n.nodeValue;
      if (v.length < 12 || !KEY.test(v)) continue;
      for (k = 0; k < RULES.length; k++) v = v.replace(RULES[k][0], RULES[k][1]);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
  }

  /* 2 */
  var prod = null, prodP = null;
  function getProd() {
    if (!handle) return Promise.resolve(null);
    return prodP || (prodP = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { prod = p; return p; }).catch(function () { return null; }));
  }
  function swatches() {
    if (!prod) { getProd().then(function (p) { if (p) swatches(); }); return; }
    var main = document.querySelector('main') || document, sel = {};
    prod.options.forEach(function (o, i) {
      var c = main.querySelector('input[type="radio"][name="' + o.name + '"]:checked');
      sel[i] = c ? c.value : null;
    });
    prod.options.forEach(function (o, i) {
      main.querySelectorAll('input[type="radio"][name="' + o.name + '"]').forEach(function (r) {
        var ok = prod.variants.some(function (v) {
          if (!v.available || v.options[i] !== r.value) return false;
          return prod.options.every(function (_, j) { return j === i || sel[j] == null || v.options[j] === sel[j]; });
        });
        var wrap = r.closest('.color-swatch') || (r.nextElementSibling && r.nextElementSibling.tagName === 'LABEL' ? r.nextElementSibling : r.parentElement);
        if (!ok && !r.checked) {
          if (!r.disabled) { r.disabled = true; r.setAttribute('aria-disabled', 'true'); }
          if (wrap) { wrap.classList.add('bf26y-so'); wrap.setAttribute('title', 'Sold out'); }
        } else if (r.disabled && r.getAttribute('aria-disabled') === 'true' && r.hasAttribute('aria-disabled')) {
          r.disabled = false; r.removeAttribute('aria-disabled');
          if (wrap) { wrap.classList.remove('bf26y-so'); wrap.removeAttribute('title'); }
        }
      });
    });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.bf26y-so');
    if (s) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('change', function () { setTimeout(swatches, 60); }, true);

  var t;
  function all() { try { copy(); if (handle) swatches(); } catch (e) {} }
  function sched() { clearTimeout(t); t = setTimeout(all, 500); }
  ready(function () {
    all(); setTimeout(all, 1500); setTimeout(all, 4000);
    rkLazy(all, function () { new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); });
  });
})();

/* 26 Oct 2026 (Alexander, Microsoft Clarity): 3 shoppers tapped a sold-out colour (socks collection, All products, SoftClip) and nothing happened while
   Add stayed live. A tap on a sold-out colour or size now says so under the options: "Mint is sold out. Pick another colour." Same on product pages,
   collection cards, the SoftClip picker and the cart's add-on row. The option still can't be picked, and Add keeps the colour that is picked. */
(function () {
  if (window.__rkSoNote) return;
  window.__rkSoNote = 1;
  var SEL = '.bf26y-so, .color-swatch.unavailable, .color-swatch--sold-out, .rk-sc__swatch, label.is-out, [data-rkqa-sw=""]';
  function inputOf(el) {
    var i = el.querySelector && el.querySelector('input');
    if (i) return i;
    if (el.htmlFor) return document.getElementById(el.htmlFor);
    var p = el.previousElementSibling;
    return p && p.tagName === 'INPUT' ? p : null;
  }
  function show(group, text, inside) {
    // inside: a collection card's quick add block, where the note goes above Add (the swatch row there has a fixed height)
    var n = inside ? inside.querySelector(':scope > .rk-so-note') : (group.nextElementSibling && group.nextElementSibling.classList.contains('rk-so-note') ? group.nextElementSibling : null);
    if (!n) { n = document.createElement('p'); n.className = 'rk-so-note'; n.setAttribute('role', 'status'); if (inside) inside.insertAdjacentElement('afterbegin', n); else group.insertAdjacentElement('afterend', n); }
    n.textContent = text;
    clearTimeout(n.__t);
    n.__t = setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 4000);
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest(SEL);
    if (!el) return;
    var inp = inputOf(el);
    if (inp && !inp.disabled && !el.matches('[data-rkqa-sw=""]')) return; // an option that can be picked (a sold-out one stays disabled)
    if (inp && inp.checked) return;
    var name = (inp && (inp.value || inp.getAttribute('aria-label'))) || el.getAttribute('aria-label') || (el.getAttribute('title') || '').replace(/\s*\(sold out\)\s*/i, '');
    if (!name || /^sold out$/i.test(name)) name = 'This one';
    var colour = !!el.closest('.color-swatch, .card__swatches-container, .rk-sc__swatch, .rkqa-card__sw, .product-form__input--swatches') || /colou?r/i.test(((el.closest('fieldset') || {}).textContent || '').slice(0, 40));
    var group = el.closest('.color-swatches-container, .card__swatches-container, .rkqa-card__sw, fieldset, .product-form__input, [role="radiogroup"], [role="group"]') || el.parentElement;
    e.preventDefault();
    var card = el.closest('.card-wrapper'), qa = card && card.querySelector('.quick-add');
    show(group, name + ' is sold out. Pick another ' + (colour ? 'colour' : 'option') + '.', qa);
  }, true);
})();

/* 26 Oct 2026 (Alexander, Microsoft Clarity): shoppers tapped the rewards bar ("Free ship", "20% off") and looked for the shipping price in the FAQ and
   policies. A tap on the bar (cart drawer, cart page, Sets, Bundle Builder) now opens a short note under it: the shipping line for the shopper's
   country (layout/theme.liquid #rk-ship-line, snippets/rk-ship-text.liquid) and what each step gives, from the ladder engine (bf26gLadder.config()). Tap again to close. */
(function () {
  if (window.__rkRklMore) return;
  window.__rkRklMore = 1;
  function steps() {
    var L = window.bf26gLadder, c = L && L.config && L.config();
    if (!c || !c.thresholds) return [];
    var prev = 0, out = [];
    c.thresholds.forEach(function (at, i) {
      var bits = [], pct = c.pcts[i] || 0, perk = (c.perks && c.perks[at]) || '';
      if (perk) bits.push(perk.replace(/^\+/, '').replace(/^\w/, function (m) { return m.toLowerCase(); }));
      if (pct > prev) bits.push(pct + '% off');
      prev = Math.max(prev, pct);
      if (bits.length) out.push([at + (i === c.thresholds.length - 1 ? '+' : '') + ' pieces', bits.join(' + ')]);
    });
    return out;
  }
  function panel() {
    var p = document.createElement('div'), ship = document.getElementById('rk-ship-line');
    p.className = 'rkl-more';
    var h = '';
    if (ship && ship.textContent.trim()) h += '<p class="rkl-more__ship">' + ship.innerHTML.trim() + '</p>';
    var s = steps();
    if (s.length) h += '<ul class="rkl-more__list">' + s.map(function (r) { return '<li><b>' + r[0] + '</b><span>' + r[1] + '</span></li>'; }).join('') + '</ul>';
    h += '<p class="rkl-more__fine">Pieces you pay for count. The free wash bag and gift do not.</p>';
    p.innerHTML = h;
    return p;
  }
  document.addEventListener('click', function (e) {
    var bar = e.target && e.target.closest && e.target.closest('.rkl');
    if (!bar || e.target.closest('a, button, input, select, label')) return;
    var open = bar.nextElementSibling && bar.nextElementSibling.classList.contains('rkl-more') ? bar.nextElementSibling : null;
    if (open) { open.parentNode.removeChild(open); bar.setAttribute('aria-expanded', 'false'); return; }
    bar.insertAdjacentElement('afterend', panel());
    bar.setAttribute('aria-expanded', 'true');
    openedAt = window.scrollY;
  });
  // closing on scroll: where the bar is sticky (collection pages) the note closes once the shopper scrolls on (about a third of a phone screen);
  // everywhere else it stays while it is being read and closes once it has scrolled off the screen
  var openedAt = 0;
  function sticky(el) { for (var a = el; a && a !== document.body; a = a.parentElement) { var p = getComputedStyle(a).position; if (p === 'sticky' || p === 'fixed') return true; } return false; }
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.rkl-more').forEach(function (m) {
      var r = m.getBoundingClientRect(), bar = m.previousElementSibling;
      var go = sticky(m) ? Math.abs(window.scrollY - openedAt) >= 200 : (r.bottom < 0 || r.top > window.innerHeight);
      if (go) { m.parentNode.removeChild(m); if (bar) bar.setAttribute('aria-expanded', 'false'); }
    });
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('rkl')) { e.preventDefault(); e.target.click(); }
  });
  function mark() { document.querySelectorAll('.rkl:not([data-rkl-tap])').forEach(function (b) { b.setAttribute('data-rkl-tap', ''); b.setAttribute('role', 'button'); b.setAttribute('tabindex', '0'); b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', (b.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) + '. Show how rewards and shipping work'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  try { new MutationObserver(function () { clearTimeout(mark.t); mark.t = setTimeout(mark, 200); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (x) {}
})();

/* 26 Oct 2026: collection cards keep their "Add" label. After a colour change Shrine rewrote it to "Add to cart" (the product page wording), so one grid
   showed both. The card's own server label is "Add" (snippets/card-product.liquid, r55 FX3); "Sold out" is left alone. */
(function () {
  if (window.__rkCardAdd) return;
  window.__rkCardAdd = 1;
  function fix(root) {
    (root || document).querySelectorAll('.card-wrapper .quick-add__submit .main-atc__label__text').forEach(function (t) {
      if (/^\s*add to cart\s*$/i.test(t.textContent)) t.textContent = 'Add';
    });
  }
  document.addEventListener('change', function (e) {
    var c = e.target && e.target.closest && e.target.closest('.card-wrapper');
    if (!c) return;
    [60, 300, 900, 1800].forEach(function (ms) { setTimeout(function () { fix(c); }, ms); });
  }, true);
})();
